import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=09e3252d"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports